<style>
  .main-part{
    width: 70%;
    /* height: 100%; */
    background-color: #ccc;
    /* background-color: black; */
    transition: 0.2s ease;
  }
  
  .tab-part{
    width: 30%;
    /* right:0px; */
    height: 100%;
    /* background-color: #54a; */
    transition: 0.2s ease;
    position: relative;
  }
  
  .profile-part{
    width: 0%;
    /* visibility: hidden; */
    /* right:0px; */
    height: 100%;
    /* background-color: #54a; */
    transition: 0.2s ease;
    position: relative;
  }
  
  
  .main-part_large {
    width: 100%;
  }
  
  .main-part_medium {
    width: 40%;
  }
  .tab-part_small {
    width: 0%;
    /* visibility: hidden; */
    /* right:-30%; */
  }
  
  .profile-part_large {
    width: 60%;
  }
  
  .conf-container{
    width: 90vw;
    margin: 0 auto;
    height: 80vh;
    display: flex;
    transition: 0.2s ease;
  }
  
  /* b4 start */
    /*!
   * Bootstrap Grid v4.1.3 (https://getbootstrap.com/)
   * Copyright 2011-2018 The Bootstrap Authors
   * Copyright 2011-2018 Twitter, Inc.
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   */
  @-ms-viewport {
    width: device-width;
  }
  
  html {
    box-sizing: border-box;
    -ms-overflow-style: scrollbar;
  }
  
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  
  .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  
  @media (min-width: 576px) {
    .container {
      max-width: 540px;
    }
  }
  
  @media (min-width: 768px) {
    .container {
      max-width: 720px;
    }
  }
  
  @media (min-width: 992px) {
    .container {
      max-width: 960px;
    }
  }
  
  @media (min-width: 1200px) {
    .container {
      max-width: 1140px;
    }
  }
  
  .container-fluid {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  
  .row {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  
  .no-gutters {
    margin-right: 0;
    margin-left: 0;
  }
  
  .no-gutters > .col,
  .no-gutters > [class*="col-"] {
    padding-right: 0;
    padding-left: 0;
  }
  
  .col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
  .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
  .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
  .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
  .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
  .col-xl-auto {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }
  
  .col {
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -ms-flex-positive: 1;
    flex-grow: 1;
    max-width: 100%;
  }
  
  .col-auto {
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  
  .col-1 {
    -ms-flex: 0 0 8.333333%;
    flex: 0 0 8.333333%;
    max-width: 8.333333%;
  }
  
  .col-2 {
    -ms-flex: 0 0 16.666667%;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
  }
  
  .col-3 {
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%;
  }
  
  .col-4 {
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
  
  .col-5 {
    -ms-flex: 0 0 41.666667%;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
  
  .col-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
  
  .col-7 {
    -ms-flex: 0 0 58.333333%;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
  
  .col-8 {
    -ms-flex: 0 0 66.666667%;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
  }
  
  .col-9 {
    -ms-flex: 0 0 75%;
    flex: 0 0 75%;
    max-width: 75%;
  }
  
  .col-10 {
    -ms-flex: 0 0 83.333333%;
    flex: 0 0 83.333333%;
    max-width: 83.333333%;
  }
  
  .col-11 {
    -ms-flex: 0 0 91.666667%;
    flex: 0 0 91.666667%;
    max-width: 91.666667%;
  }
  
  .col-12 {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
  
  .order-first {
    -ms-flex-order: -1;
    order: -1;
  }
  
  .order-last {
    -ms-flex-order: 13;
    order: 13;
  }
  
  .order-0 {
    -ms-flex-order: 0;
    order: 0;
  }
  
  .order-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  
  .order-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  
  .order-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  
  .order-4 {
    -ms-flex-order: 4;
    order: 4;
  }
  
  .order-5 {
    -ms-flex-order: 5;
    order: 5;
  }
  
  .order-6 {
    -ms-flex-order: 6;
    order: 6;
  }
  
  .order-7 {
    -ms-flex-order: 7;
    order: 7;
  }
  
  .order-8 {
    -ms-flex-order: 8;
    order: 8;
  }
  
  .order-9 {
    -ms-flex-order: 9;
    order: 9;
  }
  
  .order-10 {
    -ms-flex-order: 10;
    order: 10;
  }
  
  .order-11 {
    -ms-flex-order: 11;
    order: 11;
  }
  
  .order-12 {
    -ms-flex-order: 12;
    order: 12;
  }
  
  .offset-1 {
    margin-left: 8.333333%;
  }
  
  .offset-2 {
    margin-left: 16.666667%;
  }
  
  .offset-3 {
    margin-left: 25%;
  }
  
  .offset-4 {
    margin-left: 33.333333%;
  }
  
  .offset-5 {
    margin-left: 41.666667%;
  }
  
  .offset-6 {
    margin-left: 50%;
  }
  
  .offset-7 {
    margin-left: 58.333333%;
  }
  
  .offset-8 {
    margin-left: 66.666667%;
  }
  
  .offset-9 {
    margin-left: 75%;
  }
  
  .offset-10 {
    margin-left: 83.333333%;
  }
  
  .offset-11 {
    margin-left: 91.666667%;
  }
  
  @media (min-width: 576px) {
    .col-sm {
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
    }
    .col-sm-auto {
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      width: auto;
      max-width: none;
    }
    .col-sm-1 {
      -ms-flex: 0 0 8.333333%;
      flex: 0 0 8.333333%;
      max-width: 8.333333%;
    }
    .col-sm-2 {
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
    .col-sm-3 {
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
    .col-sm-4 {
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
    .col-sm-5 {
      -ms-flex: 0 0 41.666667%;
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
    }
    .col-sm-6 {
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
    .col-sm-7 {
      -ms-flex: 0 0 58.333333%;
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
    }
    .col-sm-8 {
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
    .col-sm-9 {
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
    .col-sm-10 {
      -ms-flex: 0 0 83.333333%;
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
    }
    .col-sm-11 {
      -ms-flex: 0 0 91.666667%;
      flex: 0 0 91.666667%;
      max-width: 91.666667%;
    }
    .col-sm-12 {
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
    .order-sm-first {
      -ms-flex-order: -1;
      order: -1;
    }
    .order-sm-last {
      -ms-flex-order: 13;
      order: 13;
    }
    .order-sm-0 {
      -ms-flex-order: 0;
      order: 0;
    }
    .order-sm-1 {
      -ms-flex-order: 1;
      order: 1;
    }
    .order-sm-2 {
      -ms-flex-order: 2;
      order: 2;
    }
    .order-sm-3 {
      -ms-flex-order: 3;
      order: 3;
    }
    .order-sm-4 {
      -ms-flex-order: 4;
      order: 4;
    }
    .order-sm-5 {
      -ms-flex-order: 5;
      order: 5;
    }
    .order-sm-6 {
      -ms-flex-order: 6;
      order: 6;
    }
    .order-sm-7 {
      -ms-flex-order: 7;
      order: 7;
    }
    .order-sm-8 {
      -ms-flex-order: 8;
      order: 8;
    }
    .order-sm-9 {
      -ms-flex-order: 9;
      order: 9;
    }
    .order-sm-10 {
      -ms-flex-order: 10;
      order: 10;
    }
    .order-sm-11 {
      -ms-flex-order: 11;
      order: 11;
    }
    .order-sm-12 {
      -ms-flex-order: 12;
      order: 12;
    }
    .offset-sm-0 {
      margin-left: 0;
    }
    .offset-sm-1 {
      margin-left: 8.333333%;
    }
    .offset-sm-2 {
      margin-left: 16.666667%;
    }
    .offset-sm-3 {
      margin-left: 25%;
    }
    .offset-sm-4 {
      margin-left: 33.333333%;
    }
    .offset-sm-5 {
      margin-left: 41.666667%;
    }
    .offset-sm-6 {
      margin-left: 50%;
    }
    .offset-sm-7 {
      margin-left: 58.333333%;
    }
    .offset-sm-8 {
      margin-left: 66.666667%;
    }
    .offset-sm-9 {
      margin-left: 75%;
    }
    .offset-sm-10 {
      margin-left: 83.333333%;
    }
    .offset-sm-11 {
      margin-left: 91.666667%;
    }
  }
  
  @media (min-width: 768px) {
    .col-md {
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
    }
    .col-md-auto {
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      width: auto;
      max-width: none;
    }
    .col-md-1 {
      -ms-flex: 0 0 8.333333%;
      flex: 0 0 8.333333%;
      max-width: 8.333333%;
    }
    .col-md-2 {
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
    .col-md-3 {
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
    .col-md-4 {
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
    .col-md-5 {
      -ms-flex: 0 0 41.666667%;
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
    }
    .col-md-6 {
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
    .col-md-7 {
      -ms-flex: 0 0 58.333333%;
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
    }
    .col-md-8 {
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
    .col-md-9 {
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
    .col-md-10 {
      -ms-flex: 0 0 83.333333%;
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
    }
    .col-md-11 {
      -ms-flex: 0 0 91.666667%;
      flex: 0 0 91.666667%;
      max-width: 91.666667%;
    }
    .col-md-12 {
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
    .order-md-first {
      -ms-flex-order: -1;
      order: -1;
    }
    .order-md-last {
      -ms-flex-order: 13;
      order: 13;
    }
    .order-md-0 {
      -ms-flex-order: 0;
      order: 0;
    }
    .order-md-1 {
      -ms-flex-order: 1;
      order: 1;
    }
    .order-md-2 {
      -ms-flex-order: 2;
      order: 2;
    }
    .order-md-3 {
      -ms-flex-order: 3;
      order: 3;
    }
    .order-md-4 {
      -ms-flex-order: 4;
      order: 4;
    }
    .order-md-5 {
      -ms-flex-order: 5;
      order: 5;
    }
    .order-md-6 {
      -ms-flex-order: 6;
      order: 6;
    }
    .order-md-7 {
      -ms-flex-order: 7;
      order: 7;
    }
    .order-md-8 {
      -ms-flex-order: 8;
      order: 8;
    }
    .order-md-9 {
      -ms-flex-order: 9;
      order: 9;
    }
    .order-md-10 {
      -ms-flex-order: 10;
      order: 10;
    }
    .order-md-11 {
      -ms-flex-order: 11;
      order: 11;
    }
    .order-md-12 {
      -ms-flex-order: 12;
      order: 12;
    }
    .offset-md-0 {
      margin-left: 0;
    }
    .offset-md-1 {
      margin-left: 8.333333%;
    }
    .offset-md-2 {
      margin-left: 16.666667%;
    }
    .offset-md-3 {
      margin-left: 25%;
    }
    .offset-md-4 {
      margin-left: 33.333333%;
    }
    .offset-md-5 {
      margin-left: 41.666667%;
    }
    .offset-md-6 {
      margin-left: 50%;
    }
    .offset-md-7 {
      margin-left: 58.333333%;
    }
    .offset-md-8 {
      margin-left: 66.666667%;
    }
    .offset-md-9 {
      margin-left: 75%;
    }
    .offset-md-10 {
      margin-left: 83.333333%;
    }
    .offset-md-11 {
      margin-left: 91.666667%;
    }
  }
  
  @media (min-width: 992px) {
    .col-lg {
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
    }
    .col-lg-auto {
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      width: auto;
      max-width: none;
    }
    .col-lg-1 {
      -ms-flex: 0 0 8.333333%;
      flex: 0 0 8.333333%;
      max-width: 8.333333%;
    }
    .col-lg-2 {
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
    .col-lg-3 {
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
    .col-lg-4 {
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
    .col-lg-5 {
      -ms-flex: 0 0 41.666667%;
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
    }
    .col-lg-6 {
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
    .col-lg-7 {
      -ms-flex: 0 0 58.333333%;
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
    }
    .col-lg-8 {
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
    .col-lg-9 {
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
    .col-lg-10 {
      -ms-flex: 0 0 83.333333%;
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
    }
    .col-lg-11 {
      -ms-flex: 0 0 91.666667%;
      flex: 0 0 91.666667%;
      max-width: 91.666667%;
    }
    .col-lg-12 {
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
    .order-lg-first {
      -ms-flex-order: -1;
      order: -1;
    }
    .order-lg-last {
      -ms-flex-order: 13;
      order: 13;
    }
    .order-lg-0 {
      -ms-flex-order: 0;
      order: 0;
    }
    .order-lg-1 {
      -ms-flex-order: 1;
      order: 1;
    }
    .order-lg-2 {
      -ms-flex-order: 2;
      order: 2;
    }
    .order-lg-3 {
      -ms-flex-order: 3;
      order: 3;
    }
    .order-lg-4 {
      -ms-flex-order: 4;
      order: 4;
    }
    .order-lg-5 {
      -ms-flex-order: 5;
      order: 5;
    }
    .order-lg-6 {
      -ms-flex-order: 6;
      order: 6;
    }
    .order-lg-7 {
      -ms-flex-order: 7;
      order: 7;
    }
    .order-lg-8 {
      -ms-flex-order: 8;
      order: 8;
    }
    .order-lg-9 {
      -ms-flex-order: 9;
      order: 9;
    }
    .order-lg-10 {
      -ms-flex-order: 10;
      order: 10;
    }
    .order-lg-11 {
      -ms-flex-order: 11;
      order: 11;
    }
    .order-lg-12 {
      -ms-flex-order: 12;
      order: 12;
    }
    .offset-lg-0 {
      margin-left: 0;
    }
    .offset-lg-1 {
      margin-left: 8.333333%;
    }
    .offset-lg-2 {
      margin-left: 16.666667%;
    }
    .offset-lg-3 {
      margin-left: 25%;
    }
    .offset-lg-4 {
      margin-left: 33.333333%;
    }
    .offset-lg-5 {
      margin-left: 41.666667%;
    }
    .offset-lg-6 {
      margin-left: 50%;
    }
    .offset-lg-7 {
      margin-left: 58.333333%;
    }
    .offset-lg-8 {
      margin-left: 66.666667%;
    }
    .offset-lg-9 {
      margin-left: 75%;
    }
    .offset-lg-10 {
      margin-left: 83.333333%;
    }
    .offset-lg-11 {
      margin-left: 91.666667%;
    }
  }
  
  @media (min-width: 1200px) {
    .col-xl {
      -ms-flex-preferred-size: 0;
      flex-basis: 0;
      -ms-flex-positive: 1;
      flex-grow: 1;
      max-width: 100%;
    }
    .col-xl-auto {
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      width: auto;
      max-width: none;
    }
    .col-xl-1 {
      -ms-flex: 0 0 8.333333%;
      flex: 0 0 8.333333%;
      max-width: 8.333333%;
    }
    .col-xl-2 {
      -ms-flex: 0 0 16.666667%;
      flex: 0 0 16.666667%;
      max-width: 16.666667%;
    }
    .col-xl-3 {
      -ms-flex: 0 0 25%;
      flex: 0 0 25%;
      max-width: 25%;
    }
    .col-xl-4 {
      -ms-flex: 0 0 33.333333%;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
    .col-xl-5 {
      -ms-flex: 0 0 41.666667%;
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
    }
    .col-xl-6 {
      -ms-flex: 0 0 50%;
      flex: 0 0 50%;
      max-width: 50%;
    }
    .col-xl-7 {
      -ms-flex: 0 0 58.333333%;
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
    }
    .col-xl-8 {
      -ms-flex: 0 0 66.666667%;
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
    .col-xl-9 {
      -ms-flex: 0 0 75%;
      flex: 0 0 75%;
      max-width: 75%;
    }
    .col-xl-10 {
      -ms-flex: 0 0 83.333333%;
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
    }
    .col-xl-11 {
      -ms-flex: 0 0 91.666667%;
      flex: 0 0 91.666667%;
      max-width: 91.666667%;
    }
    .col-xl-12 {
      -ms-flex: 0 0 100%;
      flex: 0 0 100%;
      max-width: 100%;
    }
    .order-xl-first {
      -ms-flex-order: -1;
      order: -1;
    }
    .order-xl-last {
      -ms-flex-order: 13;
      order: 13;
    }
    .order-xl-0 {
      -ms-flex-order: 0;
      order: 0;
    }
    .order-xl-1 {
      -ms-flex-order: 1;
      order: 1;
    }
    .order-xl-2 {
      -ms-flex-order: 2;
      order: 2;
    }
    .order-xl-3 {
      -ms-flex-order: 3;
      order: 3;
    }
    .order-xl-4 {
      -ms-flex-order: 4;
      order: 4;
    }
    .order-xl-5 {
      -ms-flex-order: 5;
      order: 5;
    }
    .order-xl-6 {
      -ms-flex-order: 6;
      order: 6;
    }
    .order-xl-7 {
      -ms-flex-order: 7;
      order: 7;
    }
    .order-xl-8 {
      -ms-flex-order: 8;
      order: 8;
    }
    .order-xl-9 {
      -ms-flex-order: 9;
      order: 9;
    }
    .order-xl-10 {
      -ms-flex-order: 10;
      order: 10;
    }
    .order-xl-11 {
      -ms-flex-order: 11;
      order: 11;
    }
    .order-xl-12 {
      -ms-flex-order: 12;
      order: 12;
    }
    .offset-xl-0 {
      margin-left: 0;
    }
    .offset-xl-1 {
      margin-left: 8.333333%;
    }
    .offset-xl-2 {
      margin-left: 16.666667%;
    }
    .offset-xl-3 {
      margin-left: 25%;
    }
    .offset-xl-4 {
      margin-left: 33.333333%;
    }
    .offset-xl-5 {
      margin-left: 41.666667%;
    }
    .offset-xl-6 {
      margin-left: 50%;
    }
    .offset-xl-7 {
      margin-left: 58.333333%;
    }
    .offset-xl-8 {
      margin-left: 66.666667%;
    }
    .offset-xl-9 {
      margin-left: 75%;
    }
    .offset-xl-10 {
      margin-left: 83.333333%;
    }
    .offset-xl-11 {
      margin-left: 91.666667%;
    }
  }
  
  .d-none {
    display: none !important;
  }
  
  .d-inline {
    display: inline !important;
  }
  
  .d-inline-block {
    display: inline-block !important;
  }
  
  .d-block {
    display: block !important;
  }
  
  .d-table {
    display: table !important;
  }
  
  .d-table-row {
    display: table-row !important;
  }
  
  .d-table-cell {
    display: table-cell !important;
  }
  
  .d-flex {
    display: -ms-flexbox !important;
    display: flex !important;
  }
  
  .d-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
  }
  
  @media (min-width: 576px) {
    .d-sm-none {
      display: none !important;
    }
    .d-sm-inline {
      display: inline !important;
    }
    .d-sm-inline-block {
      display: inline-block !important;
    }
    .d-sm-block {
      display: block !important;
    }
    .d-sm-table {
      display: table !important;
    }
    .d-sm-table-row {
      display: table-row !important;
    }
    .d-sm-table-cell {
      display: table-cell !important;
    }
    .d-sm-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
    .d-sm-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
  }
  
  @media (min-width: 768px) {
    .d-md-none {
      display: none !important;
    }
    .d-md-inline {
      display: inline !important;
    }
    .d-md-inline-block {
      display: inline-block !important;
    }
    .d-md-block {
      display: block !important;
    }
    .d-md-table {
      display: table !important;
    }
    .d-md-table-row {
      display: table-row !important;
    }
    .d-md-table-cell {
      display: table-cell !important;
    }
    .d-md-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
    .d-md-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
  }
  
  @media (min-width: 992px) {
    .d-lg-none {
      display: none !important;
    }
    .d-lg-inline {
      display: inline !important;
    }
    .d-lg-inline-block {
      display: inline-block !important;
    }
    .d-lg-block {
      display: block !important;
    }
    .d-lg-table {
      display: table !important;
    }
    .d-lg-table-row {
      display: table-row !important;
    }
    .d-lg-table-cell {
      display: table-cell !important;
    }
    .d-lg-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
    .d-lg-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
  }
  
  @media (min-width: 1200px) {
    .d-xl-none {
      display: none !important;
    }
    .d-xl-inline {
      display: inline !important;
    }
    .d-xl-inline-block {
      display: inline-block !important;
    }
    .d-xl-block {
      display: block !important;
    }
    .d-xl-table {
      display: table !important;
    }
    .d-xl-table-row {
      display: table-row !important;
    }
    .d-xl-table-cell {
      display: table-cell !important;
    }
    .d-xl-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
    .d-xl-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
  }
  
  @media print {
    .d-print-none {
      display: none !important;
    }
    .d-print-inline {
      display: inline !important;
    }
    .d-print-inline-block {
      display: inline-block !important;
    }
    .d-print-block {
      display: block !important;
    }
    .d-print-table {
      display: table !important;
    }
    .d-print-table-row {
      display: table-row !important;
    }
    .d-print-table-cell {
      display: table-cell !important;
    }
    .d-print-flex {
      display: -ms-flexbox !important;
      display: flex !important;
    }
    .d-print-inline-flex {
      display: -ms-inline-flexbox !important;
      display: inline-flex !important;
    }
  }
  
  .flex-row {
    -ms-flex-direction: row !important;
    flex-direction: row !important;
  }
  
  .flex-column {
    -ms-flex-direction: column !important;
    flex-direction: column !important;
  }
  
  .flex-row-reverse {
    -ms-flex-direction: row-reverse !important;
    flex-direction: row-reverse !important;
  }
  
  .flex-column-reverse {
    -ms-flex-direction: column-reverse !important;
    flex-direction: column-reverse !important;
  }
  
  .flex-wrap {
    -ms-flex-wrap: wrap !important;
    flex-wrap: wrap !important;
  }
  
  .flex-nowrap {
    -ms-flex-wrap: nowrap !important;
    flex-wrap: nowrap !important;
  }
  
  .flex-wrap-reverse {
    -ms-flex-wrap: wrap-reverse !important;
    flex-wrap: wrap-reverse !important;
  }
  
  .flex-fill {
    -ms-flex: 1 1 auto !important;
    flex: 1 1 auto !important;
  }
  
  .flex-grow-0 {
    -ms-flex-positive: 0 !important;
    flex-grow: 0 !important;
  }
  
  .flex-grow-1 {
    -ms-flex-positive: 1 !important;
    flex-grow: 1 !important;
  }
  
  .flex-shrink-0 {
    -ms-flex-negative: 0 !important;
    flex-shrink: 0 !important;
  }
  
  .flex-shrink-1 {
    -ms-flex-negative: 1 !important;
    flex-shrink: 1 !important;
  }
  
  .justify-content-start {
    -ms-flex-pack: start !important;
    justify-content: flex-start !important;
  }
  
  .justify-content-end {
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
  }
  
  .justify-content-center {
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
  
  .justify-content-between {
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
  }
  
  .justify-content-around {
    -ms-flex-pack: distribute !important;
    justify-content: space-around !important;
  }
  
  .align-items-start {
    -ms-flex-align: start !important;
    align-items: flex-start !important;
  }
  
  .align-items-end {
    -ms-flex-align: end !important;
    align-items: flex-end !important;
  }
  
  .align-items-center {
    -ms-flex-align: center !important;
    align-items: center !important;
  }
  
  .align-items-baseline {
    -ms-flex-align: baseline !important;
    align-items: baseline !important;
  }
  
  .align-items-stretch {
    -ms-flex-align: stretch !important;
    align-items: stretch !important;
  }
  
  .align-content-start {
    -ms-flex-line-pack: start !important;
    align-content: flex-start !important;
  }
  
  .align-content-end {
    -ms-flex-line-pack: end !important;
    align-content: flex-end !important;
  }
  
  .align-content-center {
    -ms-flex-line-pack: center !important;
    align-content: center !important;
  }
  
  .align-content-between {
    -ms-flex-line-pack: justify !important;
    align-content: space-between !important;
  }
  
  .align-content-around {
    -ms-flex-line-pack: distribute !important;
    align-content: space-around !important;
  }
  
  .align-content-stretch {
    -ms-flex-line-pack: stretch !important;
    align-content: stretch !important;
  }
  
  .align-self-auto {
    -ms-flex-item-align: auto !important;
    align-self: auto !important;
  }
  
  .align-self-start {
    -ms-flex-item-align: start !important;
    align-self: flex-start !important;
  }
  
  .align-self-end {
    -ms-flex-item-align: end !important;
    align-self: flex-end !important;
  }
  
  .align-self-center {
    -ms-flex-item-align: center !important;
    align-self: center !important;
  }
  
  .align-self-baseline {
    -ms-flex-item-align: baseline !important;
    align-self: baseline !important;
  }
  
  .align-self-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
  }
  
  @media (min-width: 576px) {
    .flex-sm-row {
      -ms-flex-direction: row !important;
      flex-direction: row !important;
    }
    .flex-sm-column {
      -ms-flex-direction: column !important;
      flex-direction: column !important;
    }
    .flex-sm-row-reverse {
      -ms-flex-direction: row-reverse !important;
      flex-direction: row-reverse !important;
    }
    .flex-sm-column-reverse {
      -ms-flex-direction: column-reverse !important;
      flex-direction: column-reverse !important;
    }
    .flex-sm-wrap {
      -ms-flex-wrap: wrap !important;
      flex-wrap: wrap !important;
    }
    .flex-sm-nowrap {
      -ms-flex-wrap: nowrap !important;
      flex-wrap: nowrap !important;
    }
    .flex-sm-wrap-reverse {
      -ms-flex-wrap: wrap-reverse !important;
      flex-wrap: wrap-reverse !important;
    }
    .flex-sm-fill {
      -ms-flex: 1 1 auto !important;
      flex: 1 1 auto !important;
    }
    .flex-sm-grow-0 {
      -ms-flex-positive: 0 !important;
      flex-grow: 0 !important;
    }
    .flex-sm-grow-1 {
      -ms-flex-positive: 1 !important;
      flex-grow: 1 !important;
    }
    .flex-sm-shrink-0 {
      -ms-flex-negative: 0 !important;
      flex-shrink: 0 !important;
    }
    .flex-sm-shrink-1 {
      -ms-flex-negative: 1 !important;
      flex-shrink: 1 !important;
    }
    .justify-content-sm-start {
      -ms-flex-pack: start !important;
      justify-content: flex-start !important;
    }
    .justify-content-sm-end {
      -ms-flex-pack: end !important;
      justify-content: flex-end !important;
    }
    .justify-content-sm-center {
      -ms-flex-pack: center !important;
      justify-content: center !important;
    }
    .justify-content-sm-between {
      -ms-flex-pack: justify !important;
      justify-content: space-between !important;
    }
    .justify-content-sm-around {
      -ms-flex-pack: distribute !important;
      justify-content: space-around !important;
    }
    .align-items-sm-start {
      -ms-flex-align: start !important;
      align-items: flex-start !important;
    }
    .align-items-sm-end {
      -ms-flex-align: end !important;
      align-items: flex-end !important;
    }
    .align-items-sm-center {
      -ms-flex-align: center !important;
      align-items: center !important;
    }
    .align-items-sm-baseline {
      -ms-flex-align: baseline !important;
      align-items: baseline !important;
    }
    .align-items-sm-stretch {
      -ms-flex-align: stretch !important;
      align-items: stretch !important;
    }
    .align-content-sm-start {
      -ms-flex-line-pack: start !important;
      align-content: flex-start !important;
    }
    .align-content-sm-end {
      -ms-flex-line-pack: end !important;
      align-content: flex-end !important;
    }
    .align-content-sm-center {
      -ms-flex-line-pack: center !important;
      align-content: center !important;
    }
    .align-content-sm-between {
      -ms-flex-line-pack: justify !important;
      align-content: space-between !important;
    }
    .align-content-sm-around {
      -ms-flex-line-pack: distribute !important;
      align-content: space-around !important;
    }
    .align-content-sm-stretch {
      -ms-flex-line-pack: stretch !important;
      align-content: stretch !important;
    }
    .align-self-sm-auto {
      -ms-flex-item-align: auto !important;
      align-self: auto !important;
    }
    .align-self-sm-start {
      -ms-flex-item-align: start !important;
      align-self: flex-start !important;
    }
    .align-self-sm-end {
      -ms-flex-item-align: end !important;
      align-self: flex-end !important;
    }
    .align-self-sm-center {
      -ms-flex-item-align: center !important;
      align-self: center !important;
    }
    .align-self-sm-baseline {
      -ms-flex-item-align: baseline !important;
      align-self: baseline !important;
    }
    .align-self-sm-stretch {
      -ms-flex-item-align: stretch !important;
      align-self: stretch !important;
    }
  }
  
  @media (min-width: 768px) {
    .flex-md-row {
      -ms-flex-direction: row !important;
      flex-direction: row !important;
    }
    .flex-md-column {
      -ms-flex-direction: column !important;
      flex-direction: column !important;
    }
    .flex-md-row-reverse {
      -ms-flex-direction: row-reverse !important;
      flex-direction: row-reverse !important;
    }
    .flex-md-column-reverse {
      -ms-flex-direction: column-reverse !important;
      flex-direction: column-reverse !important;
    }
    .flex-md-wrap {
      -ms-flex-wrap: wrap !important;
      flex-wrap: wrap !important;
    }
    .flex-md-nowrap {
      -ms-flex-wrap: nowrap !important;
      flex-wrap: nowrap !important;
    }
    .flex-md-wrap-reverse {
      -ms-flex-wrap: wrap-reverse !important;
      flex-wrap: wrap-reverse !important;
    }
    .flex-md-fill {
      -ms-flex: 1 1 auto !important;
      flex: 1 1 auto !important;
    }
    .flex-md-grow-0 {
      -ms-flex-positive: 0 !important;
      flex-grow: 0 !important;
    }
    .flex-md-grow-1 {
      -ms-flex-positive: 1 !important;
      flex-grow: 1 !important;
    }
    .flex-md-shrink-0 {
      -ms-flex-negative: 0 !important;
      flex-shrink: 0 !important;
    }
    .flex-md-shrink-1 {
      -ms-flex-negative: 1 !important;
      flex-shrink: 1 !important;
    }
    .justify-content-md-start {
      -ms-flex-pack: start !important;
      justify-content: flex-start !important;
    }
    .justify-content-md-end {
      -ms-flex-pack: end !important;
      justify-content: flex-end !important;
    }
    .justify-content-md-center {
      -ms-flex-pack: center !important;
      justify-content: center !important;
    }
    .justify-content-md-between {
      -ms-flex-pack: justify !important;
      justify-content: space-between !important;
    }
    .justify-content-md-around {
      -ms-flex-pack: distribute !important;
      justify-content: space-around !important;
    }
    .align-items-md-start {
      -ms-flex-align: start !important;
      align-items: flex-start !important;
    }
    .align-items-md-end {
      -ms-flex-align: end !important;
      align-items: flex-end !important;
    }
    .align-items-md-center {
      -ms-flex-align: center !important;
      align-items: center !important;
    }
    .align-items-md-baseline {
      -ms-flex-align: baseline !important;
      align-items: baseline !important;
    }
    .align-items-md-stretch {
      -ms-flex-align: stretch !important;
      align-items: stretch !important;
    }
    .align-content-md-start {
      -ms-flex-line-pack: start !important;
      align-content: flex-start !important;
    }
    .align-content-md-end {
      -ms-flex-line-pack: end !important;
      align-content: flex-end !important;
    }
    .align-content-md-center {
      -ms-flex-line-pack: center !important;
      align-content: center !important;
    }
    .align-content-md-between {
      -ms-flex-line-pack: justify !important;
      align-content: space-between !important;
    }
    .align-content-md-around {
      -ms-flex-line-pack: distribute !important;
      align-content: space-around !important;
    }
    .align-content-md-stretch {
      -ms-flex-line-pack: stretch !important;
      align-content: stretch !important;
    }
    .align-self-md-auto {
      -ms-flex-item-align: auto !important;
      align-self: auto !important;
    }
    .align-self-md-start {
      -ms-flex-item-align: start !important;
      align-self: flex-start !important;
    }
    .align-self-md-end {
      -ms-flex-item-align: end !important;
      align-self: flex-end !important;
    }
    .align-self-md-center {
      -ms-flex-item-align: center !important;
      align-self: center !important;
    }
    .align-self-md-baseline {
      -ms-flex-item-align: baseline !important;
      align-self: baseline !important;
    }
    .align-self-md-stretch {
      -ms-flex-item-align: stretch !important;
      align-self: stretch !important;
    }
  }
  
  @media (min-width: 992px) {
    .flex-lg-row {
      -ms-flex-direction: row !important;
      flex-direction: row !important;
    }
    .flex-lg-column {
      -ms-flex-direction: column !important;
      flex-direction: column !important;
    }
    .flex-lg-row-reverse {
      -ms-flex-direction: row-reverse !important;
      flex-direction: row-reverse !important;
    }
    .flex-lg-column-reverse {
      -ms-flex-direction: column-reverse !important;
      flex-direction: column-reverse !important;
    }
    .flex-lg-wrap {
      -ms-flex-wrap: wrap !important;
      flex-wrap: wrap !important;
    }
    .flex-lg-nowrap {
      -ms-flex-wrap: nowrap !important;
      flex-wrap: nowrap !important;
    }
    .flex-lg-wrap-reverse {
      -ms-flex-wrap: wrap-reverse !important;
      flex-wrap: wrap-reverse !important;
    }
    .flex-lg-fill {
      -ms-flex: 1 1 auto !important;
      flex: 1 1 auto !important;
    }
    .flex-lg-grow-0 {
      -ms-flex-positive: 0 !important;
      flex-grow: 0 !important;
    }
    .flex-lg-grow-1 {
      -ms-flex-positive: 1 !important;
      flex-grow: 1 !important;
    }
    .flex-lg-shrink-0 {
      -ms-flex-negative: 0 !important;
      flex-shrink: 0 !important;
    }
    .flex-lg-shrink-1 {
      -ms-flex-negative: 1 !important;
      flex-shrink: 1 !important;
    }
    .justify-content-lg-start {
      -ms-flex-pack: start !important;
      justify-content: flex-start !important;
    }
    .justify-content-lg-end {
      -ms-flex-pack: end !important;
      justify-content: flex-end !important;
    }
    .justify-content-lg-center {
      -ms-flex-pack: center !important;
      justify-content: center !important;
    }
    .justify-content-lg-between {
      -ms-flex-pack: justify !important;
      justify-content: space-between !important;
    }
    .justify-content-lg-around {
      -ms-flex-pack: distribute !important;
      justify-content: space-around !important;
    }
    .align-items-lg-start {
      -ms-flex-align: start !important;
      align-items: flex-start !important;
    }
    .align-items-lg-end {
      -ms-flex-align: end !important;
      align-items: flex-end !important;
    }
    .align-items-lg-center {
      -ms-flex-align: center !important;
      align-items: center !important;
    }
    .align-items-lg-baseline {
      -ms-flex-align: baseline !important;
      align-items: baseline !important;
    }
    .align-items-lg-stretch {
      -ms-flex-align: stretch !important;
      align-items: stretch !important;
    }
    .align-content-lg-start {
      -ms-flex-line-pack: start !important;
      align-content: flex-start !important;
    }
    .align-content-lg-end {
      -ms-flex-line-pack: end !important;
      align-content: flex-end !important;
    }
    .align-content-lg-center {
      -ms-flex-line-pack: center !important;
      align-content: center !important;
    }
    .align-content-lg-between {
      -ms-flex-line-pack: justify !important;
      align-content: space-between !important;
    }
    .align-content-lg-around {
      -ms-flex-line-pack: distribute !important;
      align-content: space-around !important;
    }
    .align-content-lg-stretch {
      -ms-flex-line-pack: stretch !important;
      align-content: stretch !important;
    }
    .align-self-lg-auto {
      -ms-flex-item-align: auto !important;
      align-self: auto !important;
    }
    .align-self-lg-start {
      -ms-flex-item-align: start !important;
      align-self: flex-start !important;
    }
    .align-self-lg-end {
      -ms-flex-item-align: end !important;
      align-self: flex-end !important;
    }
    .align-self-lg-center {
      -ms-flex-item-align: center !important;
      align-self: center !important;
    }
    .align-self-lg-baseline {
      -ms-flex-item-align: baseline !important;
      align-self: baseline !important;
    }
    .align-self-lg-stretch {
      -ms-flex-item-align: stretch !important;
      align-self: stretch !important;
    }
  }
  
  @media (min-width: 1200px) {
    .flex-xl-row {
      -ms-flex-direction: row !important;
      flex-direction: row !important;
    }
    .flex-xl-column {
      -ms-flex-direction: column !important;
      flex-direction: column !important;
    }
    .flex-xl-row-reverse {
      -ms-flex-direction: row-reverse !important;
      flex-direction: row-reverse !important;
    }
    .flex-xl-column-reverse {
      -ms-flex-direction: column-reverse !important;
      flex-direction: column-reverse !important;
    }
    .flex-xl-wrap {
      -ms-flex-wrap: wrap !important;
      flex-wrap: wrap !important;
    }
    .flex-xl-nowrap {
      -ms-flex-wrap: nowrap !important;
      flex-wrap: nowrap !important;
    }
    .flex-xl-wrap-reverse {
      -ms-flex-wrap: wrap-reverse !important;
      flex-wrap: wrap-reverse !important;
    }
    .flex-xl-fill {
      -ms-flex: 1 1 auto !important;
      flex: 1 1 auto !important;
    }
    .flex-xl-grow-0 {
      -ms-flex-positive: 0 !important;
      flex-grow: 0 !important;
    }
    .flex-xl-grow-1 {
      -ms-flex-positive: 1 !important;
      flex-grow: 1 !important;
    }
    .flex-xl-shrink-0 {
      -ms-flex-negative: 0 !important;
      flex-shrink: 0 !important;
    }
    .flex-xl-shrink-1 {
      -ms-flex-negative: 1 !important;
      flex-shrink: 1 !important;
    }
    .justify-content-xl-start {
      -ms-flex-pack: start !important;
      justify-content: flex-start !important;
    }
    .justify-content-xl-end {
      -ms-flex-pack: end !important;
      justify-content: flex-end !important;
    }
    .justify-content-xl-center {
      -ms-flex-pack: center !important;
      justify-content: center !important;
    }
    .justify-content-xl-between {
      -ms-flex-pack: justify !important;
      justify-content: space-between !important;
    }
    .justify-content-xl-around {
      -ms-flex-pack: distribute !important;
      justify-content: space-around !important;
    }
    .align-items-xl-start {
      -ms-flex-align: start !important;
      align-items: flex-start !important;
    }
    .align-items-xl-end {
      -ms-flex-align: end !important;
      align-items: flex-end !important;
    }
    .align-items-xl-center {
      -ms-flex-align: center !important;
      align-items: center !important;
    }
    .align-items-xl-baseline {
      -ms-flex-align: baseline !important;
      align-items: baseline !important;
    }
    .align-items-xl-stretch {
      -ms-flex-align: stretch !important;
      align-items: stretch !important;
    }
    .align-content-xl-start {
      -ms-flex-line-pack: start !important;
      align-content: flex-start !important;
    }
    .align-content-xl-end {
      -ms-flex-line-pack: end !important;
      align-content: flex-end !important;
    }
    .align-content-xl-center {
      -ms-flex-line-pack: center !important;
      align-content: center !important;
    }
    .align-content-xl-between {
      -ms-flex-line-pack: justify !important;
      align-content: space-between !important;
    }
    .align-content-xl-around {
      -ms-flex-line-pack: distribute !important;
      align-content: space-around !important;
    }
    .align-content-xl-stretch {
      -ms-flex-line-pack: stretch !important;
      align-content: stretch !important;
    }
    .align-self-xl-auto {
      -ms-flex-item-align: auto !important;
      align-self: auto !important;
    }
    .align-self-xl-start {
      -ms-flex-item-align: start !important;
      align-self: flex-start !important;
    }
    .align-self-xl-end {
      -ms-flex-item-align: end !important;
      align-self: flex-end !important;
    }
    .align-self-xl-center {
      -ms-flex-item-align: center !important;
      align-self: center !important;
    }
    .align-self-xl-baseline {
      -ms-flex-item-align: baseline !important;
      align-self: baseline !important;
    }
    .align-self-xl-stretch {
      -ms-flex-item-align: stretch !important;
      align-self: stretch !important;
    }
  }
  /*# sourceMappingURL=bootstrap-grid.css.map */
    /* b4 end */
    
  html {
    height: 100%;
  }
  
  .overflow-hidden{
    overflow: hidden!important;
  } 
  
  .row{
    display: -webkit-box;
      display: flex;
      -webkit-box-flex: 1;
      flex: 1 0 100%;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
  }
  
  .container-fluid{
    width: 100%;
      padding-right: 15px;
      padding-left: 15px;
      margin-right: auto;
      margin-left: auto;
  }
  
  .mb-lg-0{
    margin-bottom:0;
  }
  /* body {
    min-width: 320px;
    height: 100%;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    background-color: #f5f5f5;
  } */ 
  
  .svg-active {
    fill: white;
  }
  
    .meeting-details-label {
      display: inline-block;
      width: 200px;
      font-weight: 600;
    }
  
    .card {
      max-width: 60rem;
      border: 1px solid gray;
      border-radius: 11px;
      padding: 25px;
    }
  
    .card-header{
      margin-top:5px;
    }
  
    .card-title{
      text-align: center;
    }
  
    .w-100{
      width: 100%;
    }
  
    .h-100{
      height: 100%;
    }
  
    .bg-success{
      background-color: #28a745!important;
    }
  
    .btn-meeting.active.focus, .btn-meeting.active:focus, .btn-meeting.focus, .btn-meeting:active.focus, .btn-meeting:active:focus, .btn-meeting:focus {
      outline: 0px auto -webkit-focus-ring-color !important;
      outline-offset: -2px;
    }
  
    .meeting-full-height{
      min-height: 90vh;
      align-items: center;
    }
  
    .meeting-partial-height{
      min-height: 500px;
    }
  
    .dropdown-menu{
      min-width: 34rem;
    } 
  
    .attendee-speaking{
      padding: 7px;
      background: #1a69ad;
      border-radius: 12px;
      text-align: center;
      color: white;
      position: absolute;
      /* top: 8px; */
      left: 28%;
      z-index: 1;
    }
  
    .bootbox > .modal-dialog{
      top: 30%;
    }
    .list-group-item{
      border: 0px;
    }

    .full-booklet-height {
      height: 700px;
    }
    
  </style>
  <!-- Initial meeting authentication screen with meeting and name inputs -->
  
  <div id="flow-authenticate" class="flow p-2">
    <!-- <div class="text-muted" style="position:fixed;right:3px;bottom:3px" id="sdk-version"></div> -->
    <div class="container">
      <!-- <div class="row d-flex justify-content-center" style="border:1px solid lightgray; border-radius: 30px;" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}"> -->
        <div class="row d-flex justify-content-center conference-details-container" [ngClass]="{'meeting-full-height' : app.participantType == 'c'}">
        <!-- <div class="row d-flex justify-content-center align-items-center" style="min-height: 500px;"> -->
        <div class="col-md-8">
          <form id="form-authenticate">
            <div class="row">
              <div class="row justify-content-center">
                <h1 class="h3 mb-5 font-weight-normal">
                  {{workflowStepName}}
                </h1>
              </div>
              <div class="row mt-3">
                <span class="meeting-details-label">Scheduled Date:</span> <span>{{ scheduleInfo.scheduledDate | fourDotFiveDateFormatPipe }}, {{ scheduleInfo.scheduledTimeLabel }} </span>
                <span *ngIf="scheduleInfo.timeZone != '-'">
                  &nbsp; in {{ scheduleInfo.timeZone }}
              </span>
              </div>
              <div class="row mt-3">
                <span class="meeting-details-label">Mode:</span>
                <span [hidden]="!(mode =='VIDEO')">Video</span>
                <span [hidden]="!(mode =='AUDIO')">Audio</span>
                <span [hidden]="!(mode =='PHONE')">Phone</span>
                <span [hidden]="!(mode =='FACE_TO_FACE')">Face to Face</span>
              </div>
              <div class="row mt-3">
                <span class="meeting-details-label">Candidate:</span> <span>{{scheduleInfo.candidateDetail.firstName + " " + scheduleInfo.candidateDetail.lastName}}</span>
              </div>
              <div class="row mt-3">
                <span class="meeting-details-label">Candidate Contact:</span> <span>{{scheduleInfo.candidateDetail.phoneNumber}}, 
                  <a href="mailto:scheduleInfo.candidateDetail.email">
                    {{scheduleInfo.candidateDetail.email}}
                </a></span>
              </div>
              <div class="row mt-3">
                <span class="meeting-details-label">Role, Type and Duration:</span> 
                <span>{{scheduleInfo.roleName}}, {{scheduleInfo.jobType}} <span *ngIf="scheduleInfo.contractDuration"> ({{scheduleInfo.contractDuration | contractDurationPipe}})</span></span>
                <app-info-icon *ngIf="scheduleInfo.requisitionNote" class="pl-2"
                    [info]="scheduleInfo.requisitionNote" 
                    infoTitle="Requisition Info">
                </app-info-icon>
              </div>
              <div class="row mt-3" *ngIf="app.participantType !== 'c'">
                <span class="meeting-details-label">Requisition #:</span> 
                <span>{{scheduleInfo.reqNumber}}</span>
              </div>
              <div class="row mt-3" *ngIf="app.participantType !== 'c'">
                <span class="meeting-details-label">
                  <span *ngIf="isCorporate">BU</span>
                  <span *ngIf="!isCorporate">Client</span>:</span> 
                <span>{{scheduleInfo.requisitionBelongsTo}}</span>
                <app-info-icon class="pl-2" *ngIf="scheduleInfo.clientNote"
                    [info]="scheduleInfo.clientNote" 
                    infoTitle="Info">
                </app-info-icon>
              </div>
              <div class="row mt-3">
                <span class="meeting-details-label mb-2">Participants:</span>  
                <table class="table table-responsive table-bordered">
                  <tbody>
                    <tr *ngFor="let user of scheduleInfo.usersListToDisplay">
                      <td>{{user.userName}}</td>
                      <td>{{user.email}}</td>
                      <td *ngIf="scheduleInfo.showPhoneNumbers">{{user.phoneNumber}}</td>
                      <td>{{user.title}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row mt-3" style="display: none;">
                <label for="inputMeeting" class="sr-only">Meeting Title</label>
                <input type="name" id="inputMeeting" class="form-control" placeholder="Meeting Title" autofocus>
              </div>
              <div class="row mt-3" style="display: none;">
                <label for="inputName" class="sr-only">Your Name</label>
                <input type="name" id="inputName" class="form-control" placeholder="Your Name">
              </div>
              <div class="row mt-3" style="display: none;">
                <label for="inputRegion" class="sr-only">Media Region</label>
                <select id="inputRegion" class="form-control" style="width:100%">
                  <option value="us-east-1" selected>United States (N. Virginia)</option>
                  <option value="ap-northeast-1">Japan (Tokyo)</option>
                  <option value="ap-southeast-1">Singapore</option>
                  <option value="af-south-1">South Africa (Cape Town)</option>
                  <option value="eu-south-1">Italy (Milan)</option>
                  <option value="ap-south-1">India (Mumbai)</option>
                  <option value="ap-northeast-2">South Korea (Seoul)</option>
                  <option value="ap-southeast-2">Australia (Sydney)</option>
                  <option value="ca-central-1">Canada</option>
                  <option value="eu-central-1">Germany (Frankfurt)</option>
                  <option value="eu-north-1">Sweden (Stockholm)</option>
                  <option value="eu-west-1">Ireland</option>
                  <option value="eu-west-2">United Kingdom (London)</option>
                  <option value="eu-west-3">France (Paris)</option>
                  <option value="sa-east-1">Brazil (São Paulo)</option>
                  <option value="us-east-2">United States (Ohio)</option>
                  <option value="us-west-1">United States (N. California)</option>
                  <option value="us-west-2">United States (Oregon)</option>
                </select>
              </div>
              <div class="row mt-3" style="display: none;">
                <div class="col-12">
                  <label for="optional-features">Optional Features</label>
                  <select id="optional-features" class="form-control" style="width:100%">
                    <option value="" selected>None</option>
                    <option value="simulcast">Enable Simulcast For Chrome</option>
                    <option value="webaudio">Use WebAudio</option>
                  </select>
                </div>
              </div>
            </div>
            <div *ngIf="mode == 'VIDEO' || mode == 'AUDIO'" [hidden]="(scheduleInfo.status == 'COMPLETED')" class="row mt-3 d-flex justify-content-center">
              <div class="col-md-4">
                <button id="authenticate" class="btn btn-lg btn-primary btn-block" type="submit">Launch Meeting</button>
              </div>
            </div>
            
            <div class="row justify-content-center" *ngIf="mode == 'PHONE'">
              <h4><b>Call candidate @ {{scheduleInfo.candidateDetail.phoneNumber}}</b></h4>
            </div>
              <!-- <div class="row mt-3">
                <p>Anyone with access to the meeting link can join.</p>
              </div> -->
            <!-- <a id="to-sip-flow" class="row mt-3" href="#">Joining via SIP? Click here.</a> -->
            <div class="row mt-3">
              <div id="progress-authenticate" class="w-100 progress progress-hidden">
                <div class="w-100 progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </form>
          <!-- <button class="btn btn-primary pull-right" (click)="addParticipant()">Invite</button> -->
        </div>
      </div>
    </div>
  </div>
  
  <!-- Authenticate for SIP with meeting and voice connector ID -->
  
  <div id="flow-sip-authenticate" class="flow text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-4 d-flex justify-content-center align-items-center" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
          <form id="form-sip-authenticate">
            <h1 class="h3 mb-3 font-weight-normal">Join a meeting via SIP</h1>
            <div class="row mt-3">
              <label for="sip-inputMeeting" class="sr-only">Meeting Title</label>
              <input type="name" id="sip-inputMeeting" class="form-control" placeholder="Meeting Title" autofocus>
            </div>
            <div class="row mt-3">
              <label for="voiceConnectorId" class="sr-only">Voice Connector ID</label>
              <input type="name" id="voiceConnectorId" class="form-control" placeholder="Voice Connector ID" required>
            </div>
            <div class="row mt-3">
              <button id="button-sip-authenticate" class="btn btn-lg btn-primary btn-block" type="submit">Continue</button>
            </div>
            <div class="row mt-3">
              <p>You will need a SIP client in order to join the meeting.</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Failure card if meeting is invalid -->
  
  <div id="flow-failed-meeting" class="flow">
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
        <div class="col-md-6">
          <form id="form-failed-meeting" class="d-flex justify-content-center">
            <div class="card border-warning mb-3">
              <!-- <div id="failed-meeting" class="card-header"></div> -->
              <div class="card-body">
                <h4 class="card-title">Unable to find meeting</h4>
                  <div class="card-text">
                    <p>
                      There was an issue finding that meeting. Below are the possible issues.
                    </p>
                    <p>1) The meeting may have already ended</p>
                    <p>2) the meeting may have expired.</p>
                    <p>3) Your internet connection is down.</p>
                    <button class="btn btn-lg btn-outline-warning btn-block" (click)="goToJoinMeeting()">OK</button>
                  </div>
                <!-- <small id="failed-meeting-error" class="text-muted"></small> -->
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>


    <div id="flow-meeting-ended" class="flow p-2">
      <div class="container">
        <div class="row d-flex justify-content-center align-items-center conference-details-container" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
          <div class="col-md-6 text-center">
            <form id="form-flow-meeting-ended" class="d-flex justify-content-center">
              <div class="card border-warning mb-3" style="padding: 45px">
                <div class="card-body">
                    <h4 class="card-title font-bold mb-4 text-muted" style="font-size: 22px;">YOUR MEETING HAS ENDED.</h4>
                </div>
              </div>
            </form>
           </div>
        </div>
      </div>
    </div>
  
  <!-- Prompt for permission to get access to device labels -->
  
  <div id="flow-need-permission" class="flow" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
        <div class="col-md-4">
          <form id="form-need-permission" class="d-flex justify-content-center">
            <div class="card mb-3">
              <h3 class="card-header text-center pb-2">Permissions check</h3>
              <div class="card-body">
                <h4 class="card-title">Unable to get device labels</h4>
                <p class="card-text">In order to select media devices, we need to do a quick permissions check of your mic and camera. When the pop-up appears, choose <b>Allow</b>.</p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Display SIP URI -->
  
  <div id="flow-sip-uri" class="flow" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
    <div class="container">
      <form id="sip-uri-form">
        <div class="card border-info mb-3" style="max-width: 20rem;">
          <div class="card-header">SIP URI</div>
          <div class="card-body">
            <a id="copy-sip-uri" class="card-title" href="#">Copy</a>
            <input id="sip-uri" class="card-text">
          </div>
        </div>
      </form>
    </div>
  </div>
  
  <!-- Device management and preview screen -->
  
  <div id="flow-devices" class="flow p-2" *ngIf="!app.showSelectDevicesModal">
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center conference-details-container" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
        <div class="col-md-6">
          <form id="form-devices">
            <h1 class="h3 mb-3 font-weight-normal text-center">Select devices</h1>
            <div class="row mt-3">
              <div class="col-12 col-sm-8">
                <label for="audio-input block">Microphone</label>
                <select id="audio-input" class="form-control" style="width:100%"></select>
              </div>
              <div class="text-center col-sm-4 d-sm-block">
                <label>Preview</label>
                <div class="w-100 progress" style="margin-top:0.75rem">
                  <div id="audio-preview" class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-sm-8">
                <label for="video-input block">Camera</label>
                <select id="video-input" class="form-control" style="width:100%"></select>
              </div>
              <div class="col-sm-4 text-center d-sm-block video-preview">
                <video id="video-preview" class="w-100 h-100" style="max-width:137px;max-height:82px;border-radius:8px"></video>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-sm-8">
                <select id="video-input-quality" class="form-control" style="width:100%">
                  <option value="360p">360p (nHD) @ 15 fps (600 Kbps max)</option>
                  <option value="540p" selected>540p (qHD) @ 15 fps (1.4 Mbps max)</option>
                  <option value="720p">720p (HD) @ 15 fps (1.4 Mbps max)</option>
                </select>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-sm-8">
                <label for="audio-output block">Speaker</label>
                <select id="audio-output" class="form-control" style="width:100%"></select>
              </div>
              <div class="col-sm-4">
                <button id="button-test-sound" class="btn btn-outline-secondary btn-block h-50 d-sm-block" style="margin-top:2.5rem">Test</button>
              </div>
            </div>
      
            <div class="row mt-5 d-flex justify-content-center">
              <div class="col-md-4">
                <button id="joinButton" class="btn btn-lg btn-primary btn-block" type="submit">Join</button>
              </div>
            </div>
            <!-- <div class="row mt-3">
              <div class="col-lg">
                <p>Ready to join meeting <b><span id="info-meeting"></span></b> as <b><span id="info-name"></span></b>.</p>
              </div>
            </div> -->
          </form>
          <div id="progress-join" class="w-100 progress progress-hidden">
            <div class="w-100 progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- In-meeting screen -->
  
  <div id="flow-meeting" class="flow" style="position:relative;left:0;top:0;bottom:55px;right:0">
    <!-- <div id="flow-meeting" class="flow" style="position:absolute;left:0;top:0;bottom:55px;right:0"> -->

    <!-- PROCTORING: Fullscreen Warning Overlay (candidate only)
         Displayed whenever the candidate exits fullscreen mode while the meeting
         is active -->
    <div id="proctoring-fs-overlay"
         style="display:none; position:fixed; top:0; left:0; width:100%; height:100%;
                background:rgba(0,0,0,0.93); z-index:99999;
                flex-direction:column; align-items:center; justify-content:center;
                color:white; text-align:center;">
      <div style="max-width:480px; padding:2rem;">
        <i class="fas fa-shield-alt" style="font-size:4rem; color:#f0ad4e; margin-bottom:1.2rem; display:block;"></i>
        <h3 style="margin-bottom:0.8rem;">Fullscreen Mode Required</h3>
        <p style="margin-bottom:1.5rem; opacity:0.85; line-height:1.6;">
          This interview enforces fullscreen mode at all times to ensure a secure environment.
          Please click the button below to return.
        </p>
        <button class="btn btn-warning btn-lg"
                (click)="app.reEnterProctoringFullscreen()">
          <i class="fas fa-expand-arrows-alt mr-2"></i>Return to Fullscreen
        </button>
        <p style="margin-top:1.2rem; font-size:0.78rem; opacity:0.55;">
          A violation has been recorded. Repeated exits may result in disqualification.
        </p>
      </div>
    </div>
    <!-- <div class="p-2 d-none d-sm-block align-items-end" style="position:fixed;right:0;bottom:0;left:0;">
      <div class="row align-items-end">
        <div class="col">
          <div id="chime-meeting-id" class="text-muted"></div>
          <div id="desktop-attendee-id" class="text-muted"></div>
        </div>
        <div class="col d-none d-lg-block">
          <div id="video-uplink-bandwidth" class="text-muted text-right"></div>
          <div id="video-downlink-bandwidth" class="text-muted text-right"></div>
        </div>
      </div>
    </div> -->
    <audio id="meeting-audio" style="display:none"></audio>
    <div id="meeting-container" class="container-fluid h-100 p-0" style="display:flex; flex-flow:column">
      <!-- <div id="meeting-container" class="container-fluid h-100" style="display:flex; flex-flow:column"> -->
      <!-- <div class="row mb-3 mb-lg-0" style="flex-basis: auto;">
        <div class="col-12 col-lg-3 order-1 order-lg-1 text-center text-lg-left">
          <div id="meeting-id" class="navbar-brand text-muted m-0 m-lg-2"></div>
          <div id="mobile-chime-meeting-id" class="text-muted d-block d-sm-none" style="font-size:0.65rem;"></div>
          <div id="mobile-attendee-id" class="text-muted d-block d-sm-none mb-2" style="font-size:0.65rem;"></div>
        </div>
        <div class="col-8 col-lg-6 order-2 order-lg-2 text-left text-lg-center">
          <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle microphone">
            <button id="button-microphone" type="button" class="btn btn-success" title="Toggle microphone">
              <i class="fas fa-microphone"></i>
            </button>
            <div class="btn-group" role="group">
              <button id="button-microphone-drop" type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select microphone"></button>
              <div id="dropdown-menu-microphone" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-microphone-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                <a class="dropdown-item" href="#">Default microphone</a>
              </div>
            </div>
          </div>
          <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle camera">
            <button id="button-camera" type="button" class="btn btn-success" title="Toggle camera">
              <i class="fas fa-video"></i>
            </button>
            <div class="btn-group" role="group">
              <button id="button-camera-drop" type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select camera"></button>
              <div id="dropdown-menu-camera" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-camera-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                <a class="dropdown-item" href="#">Default camera</a>
              </div>
            </div>
          </div>
          <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle content share">
            <button id="button-content-share" type="button" class="btn btn-success" title="Toggle content share">
              <i class="fas fa-camera"></i>
            </button>
            <div class="btn-group" role="group">
              <button id="button-content-share-drop" type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select content to share"></button>
              <div id="dropdown-menu-content-share" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-content-share-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                <a id="dropdown-item-content-share-screen-capture" class="dropdown-item" href="#">Screen Capture...</a>
                <a id="dropdown-item-content-share-screen-test-video" class="dropdown-item" href="#">Test Video</a>
                <a id="dropdown-item-content-share-file-item" class="dropdown-item" href="#"><input id="content-share-item" type="file"></a>
              </div>
            </div>
          </div>
          <button id="button-pause-content-share" type="button" class="btn btn-success mx-1 mx-xl-2 my-2" title="Pause and unpause content share">
            <i class="fas fa-tv"></i>
          </button>
          <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle speaker">
            <button id="button-speaker" type="button" class="btn btn-success" title="Toggle speaker">
               <i class="fas fa-volume-up"></i>
            </button>
            <div class="btn-group" role="group">
              <button id="button-speaker-drop" type="button" class="btn btn-success dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select speaker"></button>
              <div id="dropdown-menu-speaker" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-speaker-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                <a class="dropdown-item" href="#">Default speaker</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 col-lg-3 order-3 order-lg-3 text-right text-lg-right">
          <button id="button-meeting-leave" type="button" class="btn btn-outline-success mx-1 mx-xl-2 my-2 px-4" title="Leave meeting">
            <i class="fas fa-sign-out-alt"></i>
          </button>
          <button id="button-meeting-end" type="button" class="btn btn-outline-danger mx-1 mx-xl-2 my-2 px-4" title="End meeting">
            ${require('../../node_modules/open-iconic/svg/power-standby.svg').default}
          </button>
        </div>
      </div> -->
      
       <!-- custom -->
       <div class="video-options-header border-bottom d-flex justify-content-center" style="background-color: #337ab7; color:white; z-index:2">
        <div  class="col-md-9 mt-2" style="display: flex; justify-content: space-between; align-items:center;">
  
          <!-- Mute action -->
          <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle microphone">
            <button id="button-microphone" type="button" style="position:relative" class="btn btn-meeting mr-2" title="Toggle microphone">
              <i class="fas fa-microphone" id="icon-microphone"></i><br>
              <span class="action-enabled-indicator action-enabled-indicator-microphone" id="icon-microphone-indicator"></span>
              <small style="position:relative; bottom: 3px">Mute</small>
            </button>
            <div class="btn-group btn-meeting-group" role="group">
              <button id="button-microphone-drop" type="button" class="btn btn-meeting dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select microphone">
                <span class="caret text-white"></span> <span class="sr-only"></span>
              </button>
              <div id="dropdown-menu-microphone" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-microphone-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                <a class="dropdown-item" href="#">Default microphone</a>
              </div>
            </div>
          </div>
  
  
  

  
  
  
  
  <!-- Video custom action -->
          <!-- <span>
            <i class="fas fa-video px-2 d-block"></i>
              <small>Video</small>
          </span>   -->
          <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle camera">
            <button id="button-camera" type="button" class="btn btn-meeting mr-2" title="Toggle camera">
              <i class="fas fa-video d-block" id="icon-camera"></i>
              <span class="action-enabled-indicator action-enabled-indicator-camera" id="icon-camera-indicator"></span>
              <small>Video</small>
            </button>
            <div class="btn-group btn-meeting-group" role="group">
              <button id="button-camera-drop" type="button" class="btn btn-meeting dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select camera">
                <span class="caret text-white"></span> <span class="sr-only"></span>
              </button>
              <div id="dropdown-menu-camera" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-camera-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                <a class="dropdown-item" href="#">Default camera</a>
              </div>
            </div>
          </div>
  
        <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle speaker">
          <button id="button-speaker" type="button" class="btn btn-meeting mr-2" title="Toggle speaker">
             <i class="fas fa-volume-up d-block" id="icon-speaker"></i>
             <span class="action-enabled-indicator action-enabled-indicator-speaker" id="icon-speaker-indicator"></span>
             <small>Speaker</small>
          </button>
          <div class="btn-group btn-meeting-group" role="group">
            <button id="button-speaker-drop" type="button" class="btn btn-meeting dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select speaker">
              <span class="caret text-white"></span> <span class="sr-only"></span>
            </button>
            <div id="dropdown-menu-speaker" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-speaker-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
              <a class="dropdown-item" href="#">Default speaker</a>
            </div>
          </div>
        </div>
  
  <!-- share screen custom -->
            <!-- <div class="dropdown">
              <a class="text-white text-center dropdown-toggle" data-toggle="dropdown">
                <i class="fas fa-desktop px-2 d-block"></i>
                <small>Screen</small>
              </a>
              <ul class="dropdown-menu" style="color:black">
                <li class="meeting-options">Share Screen</li>
                <li class="meeting-options">Share Window</li>
              </ul>
          </div> -->
  
          <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Toggle content share" [style.display]="app.participantType === 'c' ? 'none' : null">
            <button id="button-content-share" type="button" class="btn btn-meeting mr-2" title="Toggle content share">
              <i class="fas fa-tv d-block" id="icon-content-share"></i>
              <span class="action-enabled-indicator action-enabled-indicator-share" id="icon-content-share-indicator"></span>
              <small>Share Screen</small>
            </button>
            <div class="btn-group btn-meeting-group" role="group" style="display: none;">
              <button id="button-content-share-drop" type="button" class="btn btn-meeting dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select content to share">
                <span class="caret text-white"></span> <span class="sr-only"></span>
              </button>
              <div id="dropdown-menu-content-share" class="dropdown-menu dropdown-menu-right" aria-labelledby="button-content-share-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;">
                <a id="dropdown-item-content-share-screen-capture" class="dropdown-item" href="#">Screen Capture...</a>
                <a id="dropdown-item-content-share-screen-test-video" class="dropdown-item" href="#">Test Video</a>
                <a id="dropdown-item-content-share-file-item" class="dropdown-item" href="#"><input id="content-share-item" type="file"></a>
              </div>
            </div>
          </div>

        <!-- <span>
          <i class="fas fa-phone-slash px-2 d-block"></i>
            <small>End Call</small>
        </span>   -->
  
        <button id="button-pause-content-share" type="button" style="display:none" class="btn btn-meeting mx-1 mx-xl-2 my-2" title="Pause and unpause content share">
          <i class="fas fa-tv d-block" id="icon-pause-content-share"></i>
          <span class="action-enabled-indicator" id="icon-pause-content-share-indicator"></span>
          <small>Pause/Unpause share screen</small>
        </button>
  
        <button class="btn expand-btn btn-meeting" (click)="app.toggleParticipantsView()">
          <i class="fas fa-users d-block"></i>
          <small>Participants</small>
        </button>
        
        <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="Profile View" *ngIf="app.participantType !== 'c'">
          <button type="button" class="btn btn-meeting mr-2" (click)="app.adjacentProfileViewEnabled && app.toggleAdjacentProfileView()" title="Profile View">
          <i class="fas fa-user-edit d-block"></i>
            <small>View Profile</small> 
            <small>
              <span *ngIf="app.adjacentProfileViewEnabled">Adjacent</span>
              <span *ngIf="!app.adjacentProfileViewEnabled">Below</span>
            </small>
          </button>
          <div class="btn-group btn-meeting-group" role="group">
            <button type="button" class="btn btn-meeting dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Profile View">
              <span class="caret text-white"></span> <span class="sr-only"></span>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="button-profile-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;min-width: 15rem;">
              <a id="button-profile-adjacent" class="dropdown-item" title="Adjacent" (click)="app.onProfileViewChange(true)">
                Adjacent <i class="fas fa-check green pl-2" *ngIf="app.adjacentProfileViewEnabled"></i>
              </a>
              <a id="button-profile-below" class="dropdown-item" title="Below" (click)="app.onProfileViewChange(false)">
                Below <i class="fas fa-check green pl-2" *ngIf="!app.adjacentProfileViewEnabled"></i>
              </a>
            </div>
          </div>
        </div>

        <button class="btn expand-btn btn-meeting" data-toggle="modal" data-target="#exampleModal" (click)="app.openTestModal()">
          <i class="fas fa-cog d-block"></i>
          <small>Settings</small>
        </button>
  
        <div class="btn-group mx-1 mx-xl-2 my-2" role="group" aria-label="End/Leave Meeting">
          <button type="button" class="btn btn-meeting mr-2" title="End/Leave Meeting">
            <!-- <i class="fas fa-phone-slash px-2 d-block"></i> -->
            <i class="fas fa-sign-out-alt d-block"></i>
            <small>End</small>
          </button>
          <div class="btn-group btn-meeting-group" role="group">
            <button type="button" class="btn btn-meeting dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Select content to share">
              <span class="caret text-white"></span> <span class="sr-only"></span>
            </button>
            <div class="dropdown-menu dropdown-menu-right p-0" aria-labelledby="button-content-share-drop" x-placement="bottom-start" style="position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;min-width: 18rem;">
              <a id="button-meeting-leave"  class="dropdown-item" title="Leave meeting">
                Leave Meeting
              </a>
              <a id="button-meeting-end"  class="dropdown-item" title="End Meeting for All" [hidden]="(app.participantType !== 'u')" style="background-color: red; color:white!important">
                End Meeting for All
              </a>
            </div>
          </div>
        </div>
        </div>
        </div>
  
        <div class="col-md-12 p-0">
          <!-- <div id="roster-tile-container" class="row flex-sm-grow-1 overflow-hidden h-100 container-fluid mb-5 conf-container" style="flex: unset;"> -->
            <div id="roster-tile-container" class="col-md-12 p-0 overflow-hidden h-10 mb-5 conf-container" style="flex: unset;">
              <!-- <div id="roster-tile-container" class="col-md-12 pl-2 pr-0 overflow-hidden h-10 mb-5 conf-container" [ngClass]="{'vh-60': !app.adjacentProfileViewEnabled && app.participantType !== 'c'}" style="flex: unset;"> -->
              <div class="main-part" style="display:flex; position: relative;">
                <span id="attendee-speaking" class="attendee-speaking m-1">Speaking: </span>
                  <!-- <div class="d-flex w-100 justify-content-center align-items-center; position:absolute"> -->
                  <!-- </div> -->
                <div id="tile-container" class="col-md-12 p-0 my-4 my-sm-0" style="overflow-y: auto; max-height: 80vh;">
                  <div id="tile-area" class="v-grid">
                    <div *ngFor="let index of videoCount" id="tile-{{index}}" class="video-tile">
                      <video id="video-{{index}}" class="video-tile-video"></video>
                      <div id="fullscreen-{{index}}" class="video-tile-fullscreen" (click)="showFullScreen('video-'+ index)"><i class="fas fa-expand"></i></div>
                      <div id="nameplate-{{index}}" class="video-tile-nameplate"></div>
                      <!-- <button id="video-pause-{{index}}" class="video-tile-pause">Pause</button> -->
                    </div>
                  </div>
                </div>
                <video id="content-share-video" crossOrigin="anonymous" style="display:none"></video>
              </div>
        
              <div id="roster-message-container" class="roster-message-container d-flex flex-column h-100 tab-part">
                <div *ngIf="app.displayTab" (click)="app.toggleParticipantsView()" class="conf-close-adjacent-view"><i class="fas fa-times"></i></div>
                <tabset>
                  <tab heading="Participants">
                     <!-- participants start -->
                    <div class="bs-component m-2" style="flex: 1 1 auto; overflow-y: auto; height: 63vh; border: 1px solid lightgray;">

                      <!-- Participants in testing room -->
                      <ul id="waiting-roster" class="list-group mb-0">
                      </ul> 

                      <!-- Participants in meeting room -->
                      <ul id="roster" class="list-group">
                      </ul> 
                    </div>
                    <div [hidden]="(app.participantType !== 'u')"  class="col-xs-12 p-4" style="border: 1px solid lightgray; border-top:0;">
                      <div class="cursor-pointer d-inline-block text-center pull-left" (click)="app.toggleMuteAndUnmuteAll()">
                        <!-- <span *ngIf="app.isMuteAll" class="text-danger">
                          <span class="fa fa-microphone-slash"></span><br>
                          <small>All Muted</small>
                        </span> -->
                        <span>
                          <!-- <span *ngIf="!app.isMuteAll"> -->
                          <span class="fa fa-microphone"></span><br>
                          <small>Mute all</small>
                        </span>
                      </div>
                      <span class="pull-right text-center cursor-pointer" (click)="addParticipant()">
                        <span class="fas fa-user-plus"></span><br>
                        <small>Invite User</small>
                      </span>
        
                      <!-- <button class="btn btn-primary pull-right" (click)="addParticipant()">Invite</button> -->
                      <!-- <buttospann class="btn btn-primary pull-right" >Invite</buttospann> -->
                    </div>
                <!-- participants end -->
                  </tab>
                  <tab heading="Chat">
                  <!-- Chat start -->
                  <div class="message d-flex flex-column pt-3 col-xs-12" id="chat-container" style="flex: 1 1 auto; overflow: hidden; height: 60vh;">
                    <div class="list-group receive-message" id="All">
                      <!-- <div *ngFor="let chatMessage of app.allChatMessages" class="{{chatMessage.class}}">{{chatMessage.text}}</div> -->
                    </div>
  
                    <div class="form-group pt-3">
                      <label class="control-label" for="chat-users">
                          Chat with: 
                      </label>
                      <select class="form-control" name="chat-users" id="chat-users"
                          [(ngModel)]="app.selectedChatTopic" (ngModelChange)="app.showChatContainer(app.selectedChatTopic)"
                          required>
                          <option *ngFor="let chatUser of app.chatUsers; let $index = index"
                              value="{{chatUser.chatTopic}}" title="{{chatUser.name}}">
                              {{chatUser.name}}
                          </option>
                      </select>
                  </div>
  
                    <div class="input-group send-message" style="display:flex;flex:0 0 auto;margin-top:0.2rem;z-index: 1;">
                      <textarea class="form-control shadow-none" id="send-message" rows="2" placeholder="Type a message" style="display:inline-block; width:100%;
                        resize:none; border-color: rgba(0, 0, 0, 0.125); outline: none; padding-left: 1.4rem"></textarea>
                    </div>
                  </div>
                  <!-- chat end -->
                  </tab>
                </tabset>
              </div>
              <!-- candidate profile -->
              <div class="d-flex h-100 profile-part" style="overflow: auto;">
                <div class="col-md-12 p-1" style="position:relative">
                <div *ngIf="app.displayProfile" (click)="app.toggleAdjacentProfileView()" class="conf-close-adjacent-view"><i class="fas fa-times"></i></div>
                  <app-job-match-profile-on-conference style="margin-top:40px" *ngIf="app.isLoaded && app.participantType !== 'c' && app.adjacentProfileViewEnabled"
                      [workflowStep]="workflowStep"
                      [jobMatchId]="jobMatchId"
                      [jobId]="jobId"
                      [candidateId]="candidateId"
                      [scheduleId]="scheduleId"
                      [displaySchedules]="app.displaySchedule"
                      [displayFeedback]="app.displayFeedback"
                      [displayCommunication]="app.displayCommunication"
                      [feedbackUserIdsList]="scheduleInfo.usersList"
                      context="conference"
                      [usersToEditFeedback]="app.usersToEditFeedback"
                      [feedbackReadOnly]="!app.allowEditFeedback"
                      [externalMeetingCallId]="app.allMeetingInfo?.externalMeetingCallId"
                      (completeFeedbackCallback)="app.onFeedbackComplete()"
                      [sourceScreen]="sourceScreen"
                      [formalizeActivityPayload]="formalizeActivityPayload">
                  </app-job-match-profile-on-conference>
                </div>
              </div>
            </div>
         </div>
    </div>
  </div>

  
  <!-- Failure card if meeting cannot be joined -->
  
  <div id="flow-failed-join" class="flow">
    <div class="container">
      <form id="form-failed-join">
        <div class="card border-warning mb-3" style="max-width: 20rem;">
          <div id="failed-join" class="card-header"></div>
          <div class="card-body">
            <h4 class="card-title">Unable to join meeting</h4>
            <p class="card-text">There was an issue joining that meeting. Check your connectivity and try again.</p>
            <small id="failed-join-error" class="text-muted"></small>
          </div>
        </div>
        <button class="btn btn-lg btn-outline-warning btn-block" type="submit">OK</button>
      </form>
    </div>
  </div>
  
  <!-- Failure card if meeting is invalid -->
  
  <div id="flow-wait-for-host" class="flow" style="position: relative; bottom:50px">
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
        <div class="col-md-12">
          <form id="form-wait-for-host" class="d-flex justify-content-center">
            <div class="card border-warning mb-3">
              <div class="card-body" style="font-size: 2rem;">
                <h4 class="card-title">Waiting for the host to start the meeting.</h4>
                 
                  <p class="card-text text-center">Please wait.  <span class="fa fa-spinner fa-spin"></span></p>
                <small id="failed-meeting-error" class="text-muted"></small>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Wait for host to approve  -->
  <div id="flow-wait-for-host-to-approve" class="flow" style="position: relative; bottom:50px">
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center" [ngClass]="{'meeting-full-height' : app.participantType == 'c', 'meeting-partial-height': app.participantType !== 'c'}">
        <div class="col-md-12">
          <form id="form-wait-for-host-to-approve" class="d-flex justify-content-center">
            <div class="card border-warning mb-3">
              <div class="card-body" style="font-size: 2rem;">
                <h4 class="card-title">Waiting for the hosts approval to let you in.</h4>
                 
                  <p class="card-text text-center">Please wait.  <span class="fa fa-spinner fa-spin"></span></p>
                <small id="failed-meeting-error" class="text-muted"></small>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-2 booklet-container" [ngClass]="{'full-booklet-height': !app.isLoaded}" [hidden]="!(participantType !== 'c' && !app.adjacentProfileViewEnabled)">
    <div class="row">
      <div class="col-xs-12">
        <div class="row justify-content-center">
          <h1 class="h3 mb-5 font-weight-normal">
            {{scheduleInfo.candidateDetail.firstName + " " + scheduleInfo.candidateDetail.lastName}}'s Booklet
          </h1>
        </div>
        <!-- <uib-accordion style="min-height:3%">
          <div class="col-xs-12" uib-accordion-group  style="margin-top: 2%;">
            <uib-accordion-heading>
              <div [ngClass]="{'disableelementview' : !settings.isSectionActive()}">
                <label class="cursor-pointer"><b>Candidate Details</b></label>
              <i class="pull-right fa" [ngClass]="{'fa-minus': settings.isUsersPanelOpen, 'fa-plus': !settings.isUsersPanelOpen}"></i>
              </div>
            </uib-accordion-heading>  -->
          <app-job-match-profile-on-conference *ngIf="app.isLoaded && !app.adjacentProfileViewEnabled && context !== 'candidateCard' && app.participantType !== 'c'"
              [workflowStep]="workflowStep"
              [jobMatchId]="jobMatchId"
              [jobId]="jobId"
              [candidateId]="candidateId"
              [scheduleId]="scheduleId"
              [displaySchedules]="app.displaySchedule"
              [displayFeedback]="app.displayFeedback"
              [displayCommunication]="app.displayCommunication"
              [feedbackUserIdsList]="scheduleInfo.usersList"
              context="conference"
              [usersToEditFeedback]="app.usersToEditFeedback"
              [externalMeetingCallId]="app.allMeetingInfo?.externalMeetingCallId"
              [feedbackReadOnly]="!app.allowEditFeedback"
              (completeFeedbackCallback)="app.onFeedbackComplete()"
              [sourceScreen]="sourceScreen"
              [formalizeActivityPayload]="formalizeActivityPayload">
          </app-job-match-profile-on-conference>
  
          <tabset *ngIf="app.isLoaded && context === 'candidateCard'">
            <tab heading="Candidate Profile">
                <candidate-profile
                candidate-id="{{candidateId}}">
              </candidate-profile>
            </tab>
            <!-- <tab heading="Communication">
              <candidate-profile
                candidate-id="{{candidateId}}">
            </candidate-profile>
          </tab> -->
          </tabset>
          
          
          <!-- </div>
        </uib-accordion>
      </div>-->
    </div>  
  </div> 
  </div>
  
  <!-- Select Devices start -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <!-- <div class="modal fade" id="exampleModal" [hidden]="!(app.showSelectDevicesModal)" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"> -->
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header main-modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="app.closeSelectDevicesModal()">×</button>
              <h4 class="modal-title wrap-text-in ng-binding">{{label}}</h4>
            </div>
            
            <div class="modal-body">
              <div class="row">
                  <div class="col-xs-12">
                      <!-- content start -->
                      <div class="container"> 
                        <div class="row d-flex justify-content-center">
                          <div class="col-md-12">
                            <form id="form-devices">
                              <h1 class="h3 mt-0 mb-3 font-weight-normal text-center">Select Devices</h1>
                              <div class="row mt-3">
                                <div class="col-12 col-sm-8">
                                  <label for="audio-input block">Microphone</label>
                                  <select id="audio-input" class="form-control" style="width:100%" [disabled]="!app.isMicroPhoneOn"></select>
                                </div>
                                <div class="text-center col-sm-4 d-sm-block" [hidden]="!(app.isMicroPhoneOn)">
                                  <label>Preview</label>
                                  <div class="w-100 progress" style="margin-top:0.75rem">
                                    <div id="audio-preview" class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                  </div>
                                </div>
                                <div class="col-sm-4 red text-center d-flex align-items-end" style="font-size:13px" [hidden]="!(!app.isMicroPhoneOn)">
                                  Microphone is turned off.
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-12 col-sm-8">
                                  <label for="video-input block">Camera</label>
                                  <select id="video-input" class="form-control" style="width:100%" [disabled]="!app.isCameraOn"></select>
                                </div>
                                <div class="col-sm-4 text-center d-sm-block video-preview" [hidden]="!(app.isCameraOn)">
                                  <video id="video-preview" class="w-100 h-100" style="max-width:137px;max-height:82px;border-radius:8px"></video>
                                </div>
                                <div class="col-sm-4 red text-center d-flex align-items-end" style="font-size:13px" [hidden]="!(!app.isCameraOn)">
                                  Camera is turned off.
                                </div>
                              </div>
                              <div class="row mt-3" [hidden]="!(app.isCameraOn)">
                                <div class="col-12 col-sm-8">
                                  <select id="video-input-quality" class="form-control" style="width:100%">
                                    <option value="360p">360p (nHD) @ 15 fps (600 Kbps max)</option>
                                    <option value="540p" selected>540p (qHD) @ 15 fps (1.4 Mbps max)</option>
                                    <option value="720p">720p (HD) @ 15 fps (1.4 Mbps max)</option>
                                  </select>
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-12 col-sm-8">
                                  <label for="audio-output block">Speaker</label>
                                  <select id="audio-output" name="audio-output" class="form-control" style="width:100%" [(ngModel)]="app.selectedSpeakerName" [disabled]="!app.isSpeakerOn"></select>
                                </div>
                                <div class="col-sm-4" [hidden]="!(app.isSpeakerOn)">
                                  <button id="button-test-sound" class="btn btn-outline-secondary btn-block h-50 d-sm-block" style="margin-top:2.5rem">Test Speaker</button>
                                </div>
                                <div class="col-sm-4 red d-flex align-items-end" style="font-size:13px" [hidden]="!(!app.isSpeakerOn)">
                                  Speaker is turned off
                                </div>
                              </div> 
                            </form>
                            <div id="progress-join" class="w-100 progress progress-hidden">
                              <div class="w-100 progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Select Devices end -->
                  </div>
              </div>
            </div>
        </div>
      </div>
    </div>